import React from "react";

interface CustomCheckboxProps {
  id: string;
  className?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  id,
  className,
  checked,
  onChange,
}) => {
  return (
    <input
      id={id}
      type="checkbox"
      className={`form-check-input ${className || ""}`}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default CustomCheckbox;